import { getWeekForPlanning } from 'model/ResourcePlanning/utils';

import useObjectSearchParams from 'hooks/useObjectSearchParams';

export interface SchedulerParams {
  week: string;
  year: string;
}

export const useSchedulerParams = () => {
  const { week, year } = useObjectSearchParams<SchedulerParams>({
    week: getWeekForPlanning(new Date()).toString(),
    year: new Date().getFullYear().toString(),
  });

  return {
    week: typeof week === 'string' ? parseInt(week, 10) : week,
    year: typeof year === 'string' ? parseInt(year, 10) : year,
  };
};
